export default {
  BUTTON_PRIMARY_CLASS: 'button button--primary',
  BUTTON_SECONDARY_CLASS: 'button button--secondary',

  DISCARD_VEHICLE: 'Clear',
  CHANGE_VEHICLE: 'Change',
  ADD_VEHICLE: 'Add your vehicle',
};
